<template>
  <base-modal :box="box" :step="step" @on-back="mixin_set_init_step">
    <search v-model.trim="search" />
    <list-scroll height="380px" :border_top="true">
      <contact-group v-for="item in filter_items" :key="item.id" :item="item">
        <list-state slot="controls" :value="is_selected(item.id)" @click="toggle_select(item.id)" />
      </contact-group>
    </list-scroll>
    <i-button slot="footer-ok" size="large" type="success" :loading="is_loading" @click="save">
      {{ $t('pbx.worksheet.modal.action.child.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base';
  import Search from '../../../_base/_fragments/search';
  import ListState from '@shared/components/input/input-state-toggle';
  import ContactGroup from '@pbx/components/groups/_fragments/item-with-count';
  import { StepMixin } from '../../../_base/step-mixin';
  import { filterName } from '@shared/helpers/filter';

  export default {
    components: { BaseModal, Search, ListState, ContactGroup },
    mixins: [StepMixin],

    props: {
      list_of_groups: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        search: '',
        selected: [],
        is_loading: false
      };
    },

    computed: {
      filter_items: function() {
        return this.list_of_groups.filter(item => {
          return filterName(this.search, item.name);
        });
      }
    },

    watch: {
      'form.params.contact_groups': {
        handler: function(val) {
          this.selected = val;
        },
        immediate: true
      }
    },

    methods: {
      is_selected: function(id) {
        return this.selected.includes(id);
      },

      toggle_select(id) {
        if (this.is_selected(id)) {
          this.selected = this.selected.filter(source_id => source_id !== id);
        } else {
          this.selected.push(id);
        }
      },

      save: function() {
        this.mixin_save_step({ params: { contact_groups: this.selected } });
        this.mixin_set_step('init', { tab: 'contact_groups' });
      }
    }
  };
</script>
